<template>
    <div>
        <div class="card">
            <div class="card__body">
				<nav class="fields__item nav-line">
					<router-link :to="{name: 'revshare'}" class="nav-line__item">RevShare</router-link>
					<a class="nav-line__item active">Промокоды</a>
					<router-link
						v-if="user && (user.is_admin || user.can_transfer)"
						:to="{name: 'transfer'}" class="nav-line__item">
						Переводы
					</router-link>
					<router-link
						v-if="user && (user.is_admin || user.max_loan)"
						:to="{name: 'loan'}" class="nav-line__item">
						Кредит
					</router-link>
				</nav>

				<div class="fields__item">
					<button class="btn" @click="active = 'partnership'" :class="[active === 'partnership' ? 'btn--secondary' : 'btn--white']">Партнёрские</button>&nbsp;
					<button class="btn" @click="active = 'promocode'" :class="[active === 'promocode' ? 'btn--secondary' : 'btn--white']">Персональные</button>
				</div>
				<div v-show="active === 'partnership'" class="fields__item fields__row">
					<div class="fields__col">
						<div class="fields__item">
							<input v-model="partnership.source" class="text-field__input" type="text" placeholder="Источник" required>
							<div class="text-field__note">
								Укажите ссылку на ваш источник, где вы будете распространять реферальные коды (https://)
							</div>
						</div>
						<div class="fields__item">
							<input v-model="partnership.contacts" class="text-field__input" type="text" placeholder="Контактная информация" required>
							<div class="text-field__note">
								Укажите ваш Telegram
							</div>
						</div>
						<button
							@click="save()"
							class="btn btn--primary"
							:disabled="disableButton"
							type="submit">
							Отправить заявку
						</button>
					</div>
					<div class="fields__col">
						<div class="table-wrap" v-if="partnerships.length">
							<table class="table table--bordered">
								<thead>
									<tr>
										<th>Источник</th>
										<th>Управление</th>
									</tr>
								</thead>
								<tbody>
									<tr v-for="(partnership) in partnerships"
										:class="{
												'table--success': partnership.is_active,
												'table--secondary': ! partnership.is_active && ! partnership.declined_at,
												'table--danger': partnership.declined_at
											}">
										<td>
											{{ partnership.source }}
										</td>
										<td class="text-right">
											<div v-if="partnership.declined_at && partnership.decline_reason">
												{{ partnership.decline_reason }}
											</div>
											<button v-if="partnership.date_time && ! partnership.declined_at"
													type="button"
													@click="partnershipModal = partnership"
													class="btn btn--primary btn--xs">
												Промокоды
											</button>
											<button v-if="!partnership.is_active && !partnership.declined_at"
													disabled
													class="btn btn--secondary btn--xs">
												Ожидает проверки
											</button>
										</td>
									</tr>
								</tbody>
							</table>
						</div>
						<div class="text-center" v-else>
							<h4>Вы ещё не создали ни одной заявки на промокоды</h4>
						</div>
					</div>
				</div>
				<div v-show="active === 'promocode'" class="fields__item fields__row">
					<div class="fields__col">
						<div class="fields__item">
							<input class="text-field__input" v-model="promocode.amount" type="text" placeholder="Сумма промокода" required>
							<div class="text-field__note">
								Укажите сумму, которая будет начисляться на баланс при активации промокода
							</div>
						</div>
						<div class="fields__item">
							<input class="text-field__input" v-model="promocode.activation" type="number" placeholder="Количество активаций" required>
							<div class="text-field__note">
								С вашего баланса будет списана сумма: сумма промокода * количество активаций
							</div>
						</div>
						<button
							@click="savePromocode()"
							:disabled="disableButton"
							class="btn btn--primary"
							type="submit">
							Создать промокод
						</button>
					</div>
					<div class="fields__col">
						<div class="table-wrap" v-if="promocodes.length">
							<table class="table table--bordered">
								<thead>
									<tr>
										<th>Промокод</th>
										<th>Сумма</th>
										<th class="text-right">Активаций</th>
									</tr>
								</thead>
								<tbody>
									<tr v-for="(promocode) in promocodes"
										:class="{
												'table--secondary': ! promocode.is_active
											}">
										<td>
											<CopyField :text="promocode.name"/>
										</td>
										<td>
											{{ $root.currency(promocode.amount) }}
										</td>
										<td class="text-right">
											Активировано {{ promocode.activations_count }} из {{ promocode.activation }}
										</td>
									</tr>
								</tbody>
							</table>
						</div>
						<div class="text-center" v-else>
							<h4>Вы ещё не создали ни одного персонального промокода</h4>
						</div>
					</div>
				</div>
            </div>
        </div>
		<Modal v-if="partnershipModal" :open-state="partnershipModal" @close="() => partnershipModal = null" :title="'Заявка ' + partnershipModal.source" dialog-class="modal--lg">
			<div>
				<div class="modal__body">
					<div class="alert alert--light" role="alert" v-if="partnershipModal.new_promo_date">
						Новые промокоды будут доступны: <strong>{{ partnershipModal.new_promo_date }}</strong>
					</div>
					<div class="table-wrap">
						<table class="table table--bordered">
							<thead>
								<tr>
									<th>Промокод</th>
									<th>Тип</th>
									<th>Активаций / (Активировано)</th>
									<th>Сумма</th>
								</tr>
							</thead>
							<tbody>
								<tr v-for="(promocode) in partnershipModal.promocodes">
									<td>
										<CopyField :text="promocode.name"/>
									</td>
									<td class="text-center">
										{{ promocode.type_title }}
										<div v-if="promocode.deposit_required" class="text-muted small">
											Нужен депозит
											<span v-if="promocode.deposit_amount">
												{{ $root.currency(promocode.deposit_amount) }}
											</span>
											<span v-if="promocode.deposit_interval">
												за {{ promocode.deposit_interval }} дней
											</span>
										</div>
									</td>
									<td class="text-center">
										{{ promocode.activation }} / ({{ promocode.activations_count }})
									</td>
									<td class="text-center">{{ promocode.amount_title }}</td>
								</tr>
							</tbody>
						</table>
					</div>
				</div>
				<div class="modal__footer">
					<button type="button" @click="partnershipModal = null" class="btn btn--secondary">Закрыть</button>
				</div>
			</div>
		</Modal>
    </div>
</template>

<script>
	import { mapState } from 'pinia';
	import { useUserStore } from '../../stores/User';
	import Modal from "../../components/blocks/Modal.vue";
	import CopyField from "../../components/blocks/CopyField.vue";

    export default {
		components: {
			Modal,
			CopyField
		},
        data() {
            return {
                domain: window.location.origin,
                partnerships: [],
                partnership: {},
                promocode: {},
                promocodes: [],
                disableButton: false,
				partnershipModal: null,
				active: 'partnership'
            }
        },
        mounted() {
            this.$root.isLoading = true;

            if (!this.$cookie.get('token')) {
                this.$root.isLoading = false;
                this.$router.go(-1);
            }

            this.get();
        },

		computed: {
			...mapState(useUserStore, ['user'])
		},

        methods: {
            get() {
                this.$root.axios.get('/api/partnerships')
                .then(res => {
                    this.partnerships = res.data.partnerships;
                    this.promocodes = res.data.promocodes;
                    this.$root.isLoading = false;
                });
            },
            save() {
                if (!this.partnership.source) {
                    return this.$toast.error('Укажите ваш источник');
                }

                if (!this.partnership.contacts) {
                    return this.$toast.error('Укажите контактные данные');
                }

                this.disableButton = true;
                this.$root.axios.post('/api/partnerships', this.partnership)
                .then(res => {
                    this.disableButton = false;
                    this.partnership = {};

                    this.$toast.success(res.data.message);

                    this.get();
                }).catch(error => {
                    this.disableButton = false;

                    this.$toast.error(this.$root.graphql.axiosGetError(error));
                });
            },
            savePromocode() {
                if (!this.promocode.amount) {
                    return this.$toast.error('Укажите сумму промокода');
                }

                if (!this.promocode.activation) {
                    return this.$toast.error('Укажите количество активаций');
                }
                
                this.disableButton = true;
                this.$root.axios.post('/api/partnerships/promocode', this.promocode)
                .then(res => {
                    this.disableButton = false;
                    this.promocode = {};
                    this.user.balance = res.data.balance;

                    this.$toast.success(res.data.message);

                    this.get();
                }).catch(error => {
                    this.disableButton = false;

                    this.$toast.error(this.$root.graphql.axiosGetError(error));
                });
            },
            recalibrate(id) {
                this.$root.axios.post('/api/partnerships/' + id + '/recalibrate')
                .then(res => {
                    this.$toast.success(res.data.message);

                    this.get();
                }).catch(error => {
                    this.$toast.error(this.$root.graphql.axiosGetError(error));
                });
            },
        }
    }
</script>
